exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-file-list{\n    list-style: none;\n    padding:0px;\n}\n", ""]);

// exports
